declare module '#app' {
  interface NuxtApp {
    $api: typeof $fetch;
  }
}

declare module 'vue' {
  interface ComponentCustomProperties {
    $api: typeof $fetch;
  }
}

export default defineNuxtPlugin(() => {
  const { acquireToken, logout } = useEntraAuth();
  let isLoggingOut = false;

  const triggerLogout = async () => {
    if (isLoggingOut) {
      return;
    }
    isLoggingOut = true;
    await logout();
  };

  const $api = $fetch.create({
    async onResponseError({ response }) {
      if (response.status === 401 || response.status === 403) {
        const authError = useState<string | null>('auth.error');
        authError.value = 'forbidden';
        await triggerLogout();
      }
    },
    async onRequest({ options }) {
      const token = await acquireToken();
      if (!token) {
        return;
      }

      const headers = new Headers(options.headers as HeadersInit | undefined);
      headers.set('Authorization', `Bearer ${token}`);
      options.headers = headers;
    },
  });

  return {
    provide: { api: $api },
  };
});
